<script setup lang="ts">
import { transformToPercentage } from "~/utils/common";
import { truncateString } from "~/utils/stringHelpers";
import type { RouterOutput } from "~/plugins/trpc.client";
import { currencies } from "evangelist-db-schema/currencies";

type PayoutPostDto = RouterOutput["listPaychecks"][string][number];

interface Props {
  post: PayoutPostDto;
}
defineProps<Props>();
</script>

<template>
  <div
    class="bg-gradient-to-b from-white to-gray-200 border border-gray-300 hover:bg-white hover:shadow-blur cursor-pointer rounded-2xl p-6 pt-5 font-semibold"
  >
    <div class="flex flex-nowrap items-center justify-between mb-4 gap-3">
      <div class="text-gray-500 text-xs line-clamp-1">Post relevance</div>
      <div class="flex flex-row gap-2 text-xs">
        <div
          class="bg-black text-white flex-shrink-0 rounded-2xl px-2 leading-5 inline-flex items-center gap-2"
        >
          {{ transformToPercentage(post.quality_score ?? 0) }}
        </div>
        <div
          class="bg-purple-light text-black flex-shrink-0 rounded-2xl px-2 leading-5 inline-flex items-center gap-2"
        >
          {{
            Number(post.reward_amount).toLocaleString(undefined, {
              maximumFractionDigits: currencies[post.reward_currency].scale,
            })
          }}
          {{ post.reward_currency }}
        </div>
      </div>
    </div>
    <p
      class="mb-4 line-clamp-2"
      v-html="truncateString(post.tweet_text, 180)"
    ></p>
    <div class="flex justify-between items-center">
      <div class="text-black/30">
        <TimeAgo :date="new Date(post.tweet_created_at ?? new Date())" /> via
        {{ post.origin == "x" ? "X.com" : "Evangelist" }}
      </div>
    </div>
  </div>
</template>
